import { 
    GetStudentDetailsActionsTypes,
    GetStudentGradesActionsTypes,
    GetStudentAssignmentsActionsTypes,
    GetStudentAttendanceActionsTypes,
    UpdateStudentDetailsActionsTypes,
    GetStudentAnalyticsActionsTypes,
    GetStudentDetailsModel,
    GetStudentGradesModel,
    GetStudentAssignmentsModel,
    GetStudentAttendanceModel,
    UpdateStudentDetailsModel
} from './types';

export const getStudentDetailsRequest = (id: number) => (
    {
        type: GetStudentDetailsActionsTypes.GET_STUDENT_DETAILS,
        id: id
    }
);

export const getStudentGradesRequest = (studentId: number) => (
    {
        type: GetStudentGradesActionsTypes.GET_STUDENT_GRADES,
        studentId: studentId
    }
);

export const getStudentAssignmentsRequest = (studentId: number) => (
    {
        type: GetStudentAssignmentsActionsTypes.GET_STUDENT_ASSIGNMENTS,
        studentId: studentId
    }
);

export const getStudentAttendanceRequest = (studentId: number) => (
    {
        type: GetStudentAttendanceActionsTypes.GET_STUDENT_ATTENDANCE,
        studentId: studentId
    }
);

export const updateStudentDetailsRequest = (model: UpdateStudentDetailsModel) => (
    {
        type: UpdateStudentDetailsActionsTypes.PUT_UPDATE_STUDENT_DETAILS,
        model: model
    }
);

export const getStudentAnalyticsRequest = (studentId: number) => (
    {
        type: GetStudentAnalyticsActionsTypes.GET_STUDENT_ANALYTICS,
        studentId: studentId
    }
);
